/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserKrrResponse
 */
export interface UserKrrResponse {
    /**
     * 
     * @type {string}
     * @memberof UserKrrResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserKrrResponse
     */
    mobileNr?: string | null;
}

/**
 * Check if a given object implements the UserKrrResponse interface.
 */
export function instanceOfUserKrrResponse(value: object): value is UserKrrResponse {
    return true;
}

export function UserKrrResponseFromJSON(json: any): UserKrrResponse {
    return UserKrrResponseFromJSONTyped(json, false);
}

export function UserKrrResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserKrrResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'mobileNr': json['mobileNr'] === undefined ? undefined : json['mobileNr'] === null ? null : json['mobileNr'],
    };
}

export function UserKrrResponseToJSON(json: any): UserKrrResponse {
    return UserKrrResponseToJSONTyped(json, false);
}

export function UserKrrResponseToJSONTyped(value?: UserKrrResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'mobileNr': value['mobileNr'],
    };
}

